import React, { memo, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { ControlsWrapper, Divider, Title } from './Waves.styles';
import {
	ApSecondaryNav,
	ApSimpleDropdown,
	ApButtonMain,
} from '@alixpartners/ui-components';
import { PERIODS, getOption } from './constants';
import {
	INITIATIVE_TYPES,
	ITEMS_TYPE,
	TAXONOMY_DATA,
	TAXONOMY_GROUPS,
} from 'Initiatives/utils';
import { NavFilter } from 'components/NavFilter';
import { convertToArray } from 'Investigate/utils';
import { SpendCubeSettingsContext } from 'contexts/SpendCubeSettingsContext';

export const SecondaryNav = ({
	waves,
	creators,
	creator,
	type,
	wave,
	period,
	setQueryStringStateAndPush,
	taxonomy,
	isPortco
}) => {
	const history = useHistory();
	const typesOptions = [
		...INITIATIVE_TYPES[ITEMS_TYPE.CATEGORY],
		...INITIATIVE_TYPES[ITEMS_TYPE.VENDOR],
		...INITIATIVE_TYPES[ITEMS_TYPE.PT_HARMONIZATION],
		...INITIATIVE_TYPES[ITEMS_TYPE.PT_IMPROVEMENT],
	];
	const wavesOptions = waves.map(wave => ({
		label: wave.name,
		value: wave.id.toString(),
	}));
	const creatorsOptions = creators.map(creator => ({
		label: creator.name,
		value: creator.name,
	}));

	return (
		<ApSecondaryNav
			left={<Title>Wave planning</Title>}
			right={
				<ControlsWrapper>
					<NavFilter
						onChange={selected => {
							setQueryStringStateAndPush({
								taxonomy: selected,
							});
						}}
						selected={taxonomy}
						name={'Initiative taxonomy'}
						label={
							taxonomy && taxonomy.length > 0 ? 'Taxonomies' : 'All taxonomies'
						}
						options={TAXONOMY_DATA}
						groupLabels={TAXONOMY_GROUPS}
						delay={0}
					/>
					<NavFilter
						onChange={selected => {
							setQueryStringStateAndPush({
								initiativeType: selected,
							});
						}}
						selected={type}
						name={'Initiative type'}
						label={
							type && type.length > 0 ? 'Initiative types' : 'All initiatives'
						}
						options={typesOptions}
						delay={0}
					/>
				
					<NavFilter
					onChange={selected => {
						setQueryStringStateAndPush({
							initiativeWave: selected,
						});
					}}
					selected={wave}
					name={'Wave'}
					label={wave && wave.length > 0 ? 'Waves' : 'All waves'}
					options={wavesOptions}
					delay={0}
				/>
					{!isPortco&&
					<NavFilter
						onChange={selected => {
							setQueryStringStateAndPush({
								initiativeCreator: selected,
							});
						}}
						selected={creator}
						name={'Creator'}
						label={creator && creator.length > 0 ? 'Creators' : 'All creators'}
						options={creatorsOptions}
						delay={0}
					/>
				}

					<Divider />
					<ApSimpleDropdown
						options={PERIODS.map(getOption)}
						selected={getOption(period)}
						onChange={option => {
							setQueryStringStateAndPush({
								period: option.value,
							});
						}}
						label={period}
					/>
					<Divider />
					<ApButtonMain
						iconName="waves"
						onClick={() => {
							history.push('/waves/allocate');
						}}
					>
						Allocate initiatives
					</ApButtonMain>
				</ControlsWrapper>
			}
		/>
	);
};

export default memo(props => {
	const {
		initiativeType,
		initiativeWave,
		initiativeCreator,
		period,
		taxonomy,
		setQueryStringStateAndPush,
	} = useContext(QueryStringContext);
	const { settings: spendCubeSettings } = useContext(SpendCubeSettingsContext);

	return (
		<SecondaryNav
			{...props}
			taxonomy={convertToArray(taxonomy)}
			type={convertToArray(initiativeType)}
			wave={convertToArray(initiativeWave)}
			creator={convertToArray(initiativeCreator)}
			period={period}
			setQueryStringStateAndPush={setQueryStringStateAndPush}
			isPortco={spendCubeSettings.isPortco}
		/>
	);
});
